import * as yup from 'yup';

export const schemaGuide = yup.object().shape({
  client_id: yup.string().required('Cliente obrigatório'),
  professional_id: yup.string().required('Profissional obrigatório'),
  covenant_id: yup.string().required('Convênio obrigatório'),
  value: yup
    .number()
    .min(1, 'Valor deve ser maior que zero')
    .required('Valor obrigatório'),
  status: yup.string().required('Status obrigatório'),
});
